import { render, staticRenderFns } from "./point-explot.vue?vue&type=template&id=b6c9b7a0&"
import script from "./point-explot.vue?vue&type=script&lang=js&"
export * from "./point-explot.vue?vue&type=script&lang=js&"
import style0 from "./point-explot.vue?vue&type=style&index=0&id=b6c9b7a0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports